import { Box, SvgIcon } from '@mui/material';

import { TSxStyles } from '@/types/common';

export const RadioIcon = ({ checked }: { checked?: boolean }) => (
  <Box position="relative">
    <SvgIcon viewBox="0 0 24 24" sx={{ verticalAlign: 'top' }}>
      <circle r={12} cx={12} cy={12} fill="currentColor" />
    </SvgIcon>

    <SvgIcon
      viewBox="0 0 24 24"
      sx={[
        ({ transitions, palette }) => ({
          position: 'absolute',
          left: 0,
          top: 0,
          transition: transitions.create('transform'),
          fill: palette.custom.contrast[9],
        }),
        checked ? { transform: 'scale(.35)' } : false,
      ]}
    >
      <circle r={11} cx={12} cy={12} />
    </SvgIcon>
  </Box>
);

export const storyCell: TSxStyles = {
  '& > div': {
    display: 'inline-block',
  },
};
